
//
// Rebolt Bundler
//

document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("model-changed", modelChanged);
    function ensureRBPlaceholder(select) {
        try {
            const selectModelText = (window.theme && window.theme.variantStrings && window.theme.variantStrings.selectModel) || 'Select your phone model';
            // If user already has a stored model choice, don't override
            const hasPhoneStored = !!localStorage.getItem('selectedModelOption_phone');
            const hasAirpodStored = !!localStorage.getItem('selectedModelOption_airpod');
            if (hasPhoneStored || hasAirpodStored) {
                const optionExists = Array.from(select.options).some(
                    (opt) => opt.value === hasPhoneStored || opt.value === hasAirpodStored
                );
                if (optionExists) {
                    return;
                }
            }

            // If placeholder already present, remove it and add a new one
            if (select.querySelector('option.placeholder')) return;

            // Create disabled placeholder and set as selected
            if (select.options && select.options.length >= 0) {
                const placeholder = document.createElement('option');
                placeholder.value = '';
                placeholder.classList.add('placeholder')
                placeholder.disabled = true;
                placeholder.selected = true;
                placeholder.text = selectModelText;
                // Insert at top so it's the default shown value
                select.insertBefore(placeholder, select.firstChild);
            }
        } catch (e) {
            // ignore errors
        }
    }

    const observer = new MutationObserver(() => {
        const selects = document.querySelectorAll("select.RB_PC_Selector");
        if (selects.length) {
            selects.forEach(s => ensureRBPlaceholder(s));
            modelChanged();

            // Add listener to detect when app auto-populates other selects unintentionally
            selects.forEach(select => {
                if (select.dataset.rbListenerAttached) return;
                select.dataset.rbListenerAttached = 'true';
                select.dataset.prevValue = select.value; // Track previous value

                select.addEventListener('change', function () {
                    const prevValue = this.dataset.prevValue;

                    // After app code runs, check other selects
                    setTimeout(() => {
                        document.querySelectorAll("select.RB_PC_Selector").forEach(other => {
                            if (other === this) return; // skip the one that was just changed

                            // If other select was empty but now has a value, reset it
                            const otherPrevValue = other.dataset.prevValue || '';
                            if (otherPrevValue === '' && other.value !== '') {
                                other.value = '';
                                other.dataset.prevValue = '';
                            }
                        });
                    }, 50);

                    // Update this select's prev value for next time
                    this.dataset.prevValue = this.value;
                });
            });
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
})
function modelChanged() {
    let phoneModel = localStorage.getItem("selectedModelOption_phone");
    let airpodModel = localStorage.getItem("selectedModelOption_airpod");
    if (phoneModel || airpodModel) {
        const selects = document.querySelectorAll("select.RB_PC_Selector");
        selects.forEach(s => {
            const matchingOption = Array.from(s.options).find(o => o.innerText == phoneModel || o.innerText == airpodModel);
            if (matchingOption) {
                s.selectedIndex = matchingOption.index;
                // Simulate user interaction
                const event = new Event('change', { bubbles: true });
                s.dispatchEvent(event);
            }
        })
    }
}
//
//Rebolt bundler
//